/** Domain API del módulo Promociones — tipos, constantes y funciones puras.
 * Cero dependencias en infra/app/ui. Importar desde acá para evitar require cycles. */

export type {
  AppliedDiscount,
  CartEvaluationResult,
  EvaluatedCartLine,
  PricedCartLine,
  Promotion,
  PromotionApplyMode,
  PromotionChannel,
  PromotionConditions,
  PromotionKind,
  PromotionScope,
  PromotionTarget,
  PromotionTargetType,
  PromotionUpsertInput,
  PromotionWithTargets,
  ScheduleWindow,
  Weekday,
} from './domain/promotionTypes';

export { DEFAULT_PROMOTION_CHANNELS } from './domain/promotionTypes';

export type { CartEvaluationOptions } from './domain/cartEvaluationOptions';
export { normalizePromoCode, resolveManualPromoCodes } from './domain/cartEvaluationOptions';
